export default "__VITE_ASSET__67ff48a3__"